import { Resource } from '@tiller/report-sdk';

import { KPITab } from '@sonar/modules/Preferences';

export const tabToChartKPIMapping = {
  [KPITab.Revenue]: Resource.Revenue,
  [KPITab.CustomersCount]: Resource.CustomersCount,
  [KPITab.AverageSpent]: Resource.AverageSpent,
} as const;
